/**
 * Manual CIMA dentro de CIMA (Diego 2026-10-01): lo abre cualquier usuario desde su menú, sin permisos ni cuentas
 * aparte. El manual es un solo archivo versionado con el front (public/manual/manual-cima.html), así que cada
 * despliegue trae la versión vigente. Se pinta en un marco aislado para que su hoja de estilos no toque la de CIMA.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-10-01
 * @param {boolean}  isOpen   La ventana está abierta
 * @param {function} onCerrar Cierra la ventana
 */
import React, { useEffect, useState } from "react";
import { Button } from "codekit";
import Ventanax from "../Tablerox/Ventanax";
import "../Tablerox/riodo.css";
import "./manualxx.css";

const RUTA = `${process.env.PUBLIC_URL ?? ""}/manual/manual-cima.html`;

/** El archivo es el contenido del manual; aquí se le pone el documento alrededor, siempre en tema claro como CIMA */
const documentoDe = (contenido) =>
  `<!doctype html><html lang="es" data-theme="light"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"></head><body>${contenido}</body></html>`;

const Manualxx = ({ isOpen, onCerrar }) => {
  const [contenido, setContenido] = useState("");
  const [fallo, setFallo] = useState(false);

  useEffect(() => {
    if (!isOpen || contenido !== "") return undefined;
    let vigente = true;
    setFallo(false);
    fetch(RUTA, { cache: "no-cache" })
      .then((respuesta) => (respuesta.ok ? respuesta.text() : Promise.reject(new Error(String(respuesta.status)))))
      .then((texto) => vigente && setContenido(texto))
      .catch(() => vigente && setFallo(true));
    return () => {
      vigente = false;
    };
  }, [isOpen, contenido]);

  return (
    <Ventanax isOpen={isOpen} onCerrar={onCerrar} ancho="media">
      <div className="manualxx">
        <div className="rio-band">
          <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <div className="rio-band-sub">Ayuda</div>
            <div className="rio-band-title">Manual CIMA</div>
          </div>
          <Button type="button" variant="secondary" size="m" onClick={onCerrar}>
            Cerrar
          </Button>
        </div>
        {fallo && <div className="manualxx-estado">No se pudo abrir el manual. Cierra la ventana e intenta de nuevo.</div>}
        {!fallo && contenido === "" && <div className="manualxx-estado">Cargando el manual…</div>}
        {contenido !== "" && <iframe className="manualxx-marco" title="Manual CIMA" sandbox="allow-scripts" srcDoc={documentoDe(contenido)} />}
      </div>
    </Ventanax>
  );
};

export default Manualxx;
